import * as z from "zod/v4";

export const getDeliveryEstimate = {
  name: "getDeliveryEstimate" as const,
  input: z.object({
    zipCode: z.string(),
    /**
     * The store URL that is passed as a request header is the one that will
     * determine the team in the handler's context. That team should be used
     * if the team is needed.
     *
     * This param is unused, but still needs to be here for cache routing.
     */
    storeUrl_forCacheRoutingOnly: z.string(),
  }),
  output: z.object({ estimatedDeliveryDate: z.date() }),
};
